import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../services/account/account.service';
import { ProficiencyService } from '../../../../../../../services/proficiency/proficiency.service';
import { Proficiency } from '../../../../../../../models/proficiency';
import { CallbackResult, CallbackResultStatus, StandardColorRed, StandardColorTeal } from '../../../../../../../utils';

@Component({
  selector: 'app-add-proficiency-modal',
  templateUrl: './add-proficiency-modal.component.html',
  styleUrls: ['./add-proficiency-modal.component.css']
})
export class AddProficiencyModalComponent implements OnInit {

  @Input() savedCallback: (result: CallbackResult) => undefined;

  public proficiency: Proficiency = {
    id: null,
    url: null,
    name: '',
    icon_color_hex: StandardColorTeal.colorHex,
    icon_initials: '',
    create_alert_on_expiration: false,
    expiration_alert_prevents_check_in: false,
    expiration_alert_color_hex: StandardColorRed.colorHex,
    expiration_alert_has_alert_icon: false,
    no_check_in_expiration_months: null,
    expiration_after_granted_by_document_days: null,
    is_removed: false,
    created_at: null,
    updated_at: null
  };
  public hasNoCheckInExpirationMonths = false;
  public hasExpirationAfterGrantedByDocumentDays = false;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public proficiencyService: ProficiencyService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    if (!this.hasNoCheckInExpirationMonths) {
      this.proficiency.no_check_in_expiration_months = null;
    }
    if (!this.hasExpirationAfterGrantedByDocumentDays) {
      this.proficiency.expiration_after_granted_by_document_days = null;
    }

    this.proficiencyService
      .addProficiency(this.proficiency)
      .then(createdProficiency => {
        this.savedCallback({
          text: this.proficiency.name + ' created successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create proficiencies.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
